/* GY SKU8 GUARD — 16/08/2026
 * Chan tai PDP truoc khi khach tra tien.
 *
 * VI SAO CAN: compositor da duoc sua (16/08) de KEP co chu ve san 12pt
 * roi VAN VE, thay vi nem loi. Nghia la don vuot tran KHONG con bi ket o
 * khau in — nhung chu se nho hon khach ky vong. Cho chan dung phai la DAY,
 * noi chua ai tra tien.
 *
 * PDP hien dang HUA voi khach: "Longer than that and the page will tell you
 * before you order, not after." Truoc file nay, trang KHONG he bao gi —
 * do la claim sai. File nay lam cho loi hua thanh that.
 *
 * Nguon so: giao-B-va-D/DOC-VONG-4.txt muc 3, tinh tai san FLOOR_N = 71,4286 px.
 * Doi so o day PHAI doi kem so trong mo ta san pham.
 *
 * 🔴 MOI CHUOI HIEN THI PHAI LA TIENG ANH — khach la nu My 55-75.
 *    Giong: am, ngan, noi ro PHAI LAM GI, khong dung tu ky thuat.
 *
 * DAO NGUOC: xoa dong <script> nap file nay trong layout/theme.liquid.
 */
(function () {
  'use strict';

  var CAU_HINH = {
    b: { tenMoiThang: 7, tongTen: 30, kyTuMoiTen: 19 },
    d: { tenMoiThang: 4, tongTen: 24, kyTuMoiTen: 19 }
  };

  var duong = window.location.pathname;
  var cfg = null;
  if (duong.indexOf('/products/sku8-b') === 0) cfg = CAU_HINH.b;
  else if (duong.indexOf('/products/sku8-d') === 0) cfg = CAU_HINH.d;
  if (!cfg) return;

  var THANG = ['January','February','March','April','May','June',
               'July','August','September','October','November','December'];

  function oNhap(thang) {
    return document.querySelector('textarea[name="properties[' + thang + ']"]');
  }

  function tachDong(giaTri) {
    return String(giaTri || '').split('\n')
      .map(function (d) { return d.trim(); })
      .filter(function (d) { return d.length > 0; });
  }

  function layTen(dong) {
    var m = dong.split(/\s+[-–—]\s+/);
    return (m[0] || dong).trim();
  }

  function demTu(n, mot, nhieu) { return n + ' ' + (n === 1 ? mot : nhieu); }

  function hopBao(o) {
    var id = 'gy-guard-' + o.name.replace(/\W/g, '');
    var el = document.getElementById(id);
    if (!el) {
      el = document.createElement('p');
      el.id = id;
      el.className = 'gy-guard__msg';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      o.parentNode.insertBefore(el, o.nextSibling);
    }
    return el;
  }

  function kiemMotThang(thang) {
    var o = oNhap(thang);
    if (!o) return { soTen: 0, loi: [] };
    var dong = tachDong(o.value);
    var loi = [];

    if (dong.length > cfg.tenMoiThang) {
      var thua = dong.length - cfg.tenMoiThang;
      loi.push('You have ' + demTu(dong.length, 'name', 'names') + ' in ' + thang
        + '. This print fits ' + cfg.tenMoiThang + ' names in one month, so the letters stay easy to read. '
        + 'Please remove ' + demTu(thua, 'name', 'names') + ' — or move ' + (thua === 1 ? 'it' : 'them') + ' to another month.');
    }

    var qua = dong.map(layTen).filter(function (t) { return t.length > cfg.kyTuMoiTen; });
    if (qua.length) {
      loi.push((qua.length === 1 ? 'This name is a little too long: ' : 'These names are a little too long: ')
        + qua.join(', ') + '. Please shorten to ' + cfg.kyTuMoiTen
        + ' letters or fewer — the name everyone actually calls them works beautifully.');
    }

    var el = hopBao(o);
    el.textContent = loi.join(' ');
    el.style.display = loi.length ? 'block' : 'none';
    o.setAttribute('aria-invalid', loi.length ? 'true' : 'false');
    o.classList.toggle('gy-guard--sai', loi.length > 0);

    return { soTen: dong.length, loi: loi };
  }

  function hopTong() {
    var el = document.getElementById('gy-guard-tong');
    if (!el) {
      el = document.createElement('p');
      el.id = 'gy-guard-tong';
      el.className = 'gy-guard__msg gy-guard__msg--tong';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      var neo = document.querySelector('.buy-buttons-block, button[name="add"]');
      if (neo && neo.parentNode) neo.parentNode.insertBefore(el, neo);
      else return null;
    }
    return el;
  }

  function chay() {
    var tong = 0, soLoi = 0;
    THANG.forEach(function (t) {
      var kq = kiemMotThang(t);
      tong += kq.soTen;
      soLoi += kq.loi.length;
    });

    var loiTong = '';
    if (tong > cfg.tongTen) {
      loiTong = 'You have ' + demTu(tong, 'name', 'names') + ' altogether. This print holds '
        + cfg.tongTen + '. Please remove ' + demTu(tong - cfg.tongTen, 'name', 'names') + '.';
      soLoi++;
    }

    var el = hopTong();
    if (el) {
      el.textContent = loiTong || (soLoi
        ? 'Please fix the notes above, then you can add this to your cart.' : '');
      el.style.display = (loiTong || soLoi) ? 'block' : 'none';
    }

    document.body.classList.toggle('gy-guard-chan', soLoi > 0);
    var nut = document.querySelectorAll('button[name="add"], .add-to-cart-button, .shopify-payment-button__button');
    Array.prototype.forEach.call(nut, function (b) {
      b.disabled = soLoi > 0;
      b.setAttribute('aria-disabled', soLoi > 0 ? 'true' : 'false');
    });
  }

  function gan() {
    var co = false;
    THANG.forEach(function (t) {
      var o = oNhap(t);
      if (!o || o.dataset.gyGuard) return;
      o.dataset.gyGuard = '1';
      co = true;
      o.addEventListener('input', chay);
      o.addEventListener('blur', chay);
    });
    if (co) chay();
    return co;
  }

  if (!gan()) {
    var mo = new MutationObserver(function () { gan(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }
})();
